import {OrganizationPrefix} from '../../WorkspaceDrawer/Settings/types';
import {DEFAULT_WORKSPACE_LAYOUT_SETTINGS} from '../../WorkspaceDrawer/Settings/workspaceLayout/workspaceLayoutDefaults';
import {createDisplayFnFactory} from '../displayValueFactory';
import {type WorkspaceLayoutDisplayFnArgs} from '../types';
import {type WorkspaceLayoutTemplateSettings} from '../workspaceTemplatesQueries';

// Configured factory for workspace layout settings
const createDisplayFn = createDisplayFnFactory<
  WorkspaceLayoutTemplateSettings,
  WorkspaceLayoutDisplayFnArgs
>(
  args => args.currTemplateWorkspaceLayoutSettings,
  args => args.currWorkspaceLayoutSettings
);

// Legacy aliases for backward compatibility
const createBooleanDisplayFn = createDisplayFn;
const createNumberDisplayFn = createDisplayFn;

export const getAutoOrganizePrefixDisplayRow = createNumberDisplayFn({
  field: 'autoOrganizePrefix',
  label: 'Auto-organize prefix',
  defaultValue: DEFAULT_WORKSPACE_LAYOUT_SETTINGS.autoOrganizePrefix,
  formatter: value =>
    value === OrganizationPrefix.FirstPrefix ? 'First prefix' : 'Last prefix',
});

export const getShowEmptySectionsDisplayRow = createBooleanDisplayFn({
  field: 'showEmptySections',
  label: 'Show empty sections',
  defaultValue: DEFAULT_WORKSPACE_LAYOUT_SETTINGS.showEmptySections,
});

export const getSortAlphabeticallyDisplayRow = createBooleanDisplayFn({
  field: 'sortAlphabetically',
  label: 'Sort panels alphabetically',
  defaultValue: DEFAULT_WORKSPACE_LAYOUT_SETTINGS.sortAlphabetically,
});
